// extracted by mini-css-extract-plugin
export default {"Content":"PolicyPage_Content__mp55y"};